export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string, search: string = '') {
  const current = getCurrentUrl(pathname);

  if (!current || !url) return false;

  const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
  const urlPath = getCurrentUrl(normalizedUrl);

  if (search && current + search === normalizedUrl) return true;

  if (current === urlPath || (!search && (current.startsWith(urlPath + '/') || current.startsWith(urlPath + '?')))) {
    return true;
  }

  return false;
}

